import headerLogoImage from 'assets/images/landing/header-logo.png'
import styled from 'styled-components/macro'

interface WagmiLogoProps {
  className: string
  onClick?: () => void
}

const LogoImage = styled.img<{ src: string }>`
  padding: 0 20px;
  width: 124px;
`

export default function WagmiLogo({ className, onClick }: WagmiLogoProps) {
  return (
    <div className={className}>
      <LogoImage src={headerLogoImage} alt="Wagmi Logo" onClick={onClick} />
    </div>
  )
}
